import { ApiAction } from 'redux-upgrader'

export const VALIDATE_TAXES = new ApiAction('VALIDATE_TAXES')
export const GET_PRICES = new ApiAction('GET_PRICES')
export const UPDATE_VAT = new ApiAction('UPDATE_VAT')
